import { Component, Fragment } from 'react';
import Card from '../homePage/planCardContainer';
import TopFundsSection from '../homePage/topFundsSection';
import Tabs from './tabs';
import cx from 'classnames';
import styles from '../../styles/home/section.scss';
import Checklist from '../common/checklist';
import TopFundsMap from '../../constants/fundBuckets/topFunds';
import { TOP_FUNDS_STATIC, CDN_CLRSAVE_URL } from '../../constants';
import { GRAPH_POINTS } from '../../constants/homeConstants';
import CheckedTips from '../../components/common/checkedTips';
import { VARIANT_VALUES } from '../../constants/variantConstants';

interface SectionProps {
  title?: string;
  subtitle?: string;
  splitCards?: any[];
  id: string;
  cards?: any[];
  tabs?: any[];
  startInvestment: any;
  sections?: any[];
  buckets: any[];
  onTabClick: any;
  handleRowClick: (fundItem: any, id: string) => void;
  addFundToCompare: (fundItem: any) => void;
  type: string;
  variant?: string;
}

class Section extends Component<SectionProps> {
  public renderSplitCards = (
    splitCards: any,
    id: string = '',
    type: string = ''
  ) => {
    const {
      buckets,
      startInvestment,
      id: trackingSectionId,
      handleRowClick,
      addFundToCompare,
      variant,
    } = this.props;
    const isElss = type === 'elss';
    return splitCards ? (
      <div className={`${isElss ? trackingSectionId : ''}-block`}>
        {splitCards.map((data) =>
          data.type === 'plan' ? (
            <Fragment key={data.title}>
              <div
                className={cx('large-5 columns', {
                  'desktop-only': variant === VARIANT_VALUES.B,
                })}
                key={`split-${data.title}`}
                id={id}
              >
                {isElss ? (
                  <img
                    src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/plan.svg`}
                    className="verticle-align-middle mr10"
                  />
                ) : null}
                <p className="text--lg font--bold font--dark-grey mobile-only--mb20 mobile-only--center inline-block">
                  {data.title}
                </p>
                {!isElss ? (
                  <p className="text--md font--normal font--grey mb40 desktop-only">
                    {data.subtitle}
                  </p>
                ) : null}
                <div className={cx(styles['mt30'], 'mobile-only--mt20')}>
                  {Array.isArray(buckets) ? (
                    <Card
                      data={
                        buckets.filter(
                          (bucket) => bucket.bucketId === data.bucketId
                        )[0]
                      }
                      hideBenifits={data.hideBenifits}
                      hideSpacer={data.hideSpacer}
                      id={trackingSectionId}
                      minHeight={isElss}
                      variant={variant}
                    />
                  ) : null}
                  {isElss ? (
                    <div className="mt20">
                      <CheckedTips tips={data.planPoints} />
                    </div>
                  ) : null}
                </div>
              </div>
            </Fragment>
          ) : (
            <Fragment key={`${id}-${data.title}`}>
              <div
                className={cx('large-1 columns text-center', styles['mt100'], {
                  ['desktop-only']:
                    data.hideOnMobile || variant === VARIANT_VALUES.B,
                })}
              >
                <span
                  className={cx(
                    styles['or'],
                    'text--md inline-block font--bold'
                  )}
                >
                  OR
                </span>
              </div>
              <div className={cx('large-6 columns p40')} id={id}>
                {isElss ? (
                  <img
                    src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/cards.svg`}
                    className="verticle-align-middle mr10"
                  />
                ) : null}
                <p
                  className={cx(
                    'text--lg font--bold font--dark-grey mobile-only--center',
                    { 'inline-block': variant !== VARIANT_VALUES.B },
                    {
                      [styles['mobile-subtitle']]: isElss,
                    }
                  )}
                >
                  {data.title}
                </p>
                {!isElss ? (
                  <p className="text--md font--normal font--grey mb30 desktop-only">
                    {data.subtitle}
                  </p>
                ) : null}
                <TopFundsSection
                  data={{
                    funds: TopFundsMap[data.funds],
                  }}
                  fundsToShow={isElss ? 3 : 5}
                  startInvestment={startInvestment}
                  handleRowClick={handleRowClick}
                  addFundToCompare={addFundToCompare}
                  id={trackingSectionId}
                  variant={variant}
                />
                {isElss ? (
                  <div className="mt20">
                    <CheckedTips tips={data.singleFundPoints} />
                  </div>
                ) : null}
              </div>
            </Fragment>
          )
        )}
      </div>
    ) : null;
  };

  public render() {
    const {
      title,
      subtitle,
      splitCards,
      cards,
      id,
      onTabClick,
      sections,
      tabs,
      buckets,
      startInvestment,
      handleRowClick,
      type,
      addFundToCompare,
      variant,
    } = this.props;
    let selectedFund;
    const isElss = type === 'elss';
    if (tabs) {
      selectedFund = tabs.filter((tab) => tab.key === this.props[id])[0];
    }
    const hideInVariantB = ['best-tax-saving', 'grow-wealth'];
    const hideForVariantB =
      variant === VARIANT_VALUES.B && hideInVariantB.includes(id);
    if (hideForVariantB) {
      return null;
    }
    return (
      <div
        className={cx(
          'row',
          `${isElss ? 'elss' : id}-block`,
          styles['section']
        )}
        key={id}
        id={id}
        data-name={id}
      >
        {title && subtitle ? (
          <div className="columns mb40 mobile-only--mb20">
            <h2 className="font--dark-grey text--xxlg mobile-only--center mb10">
              {title}
            </h2>
            <p
              className={cx(
                'text--lg font--grey mobile-only--text--xmd desktop-only',
                styles['line-height']
              )}
            >
              {subtitle}
            </p>
          </div>
        ) : null}
        {isElss ? (
          <div className="column small-12 mb10">
            <div className="row">
              <div className="large-12 columns text-left mobile-only--mb0">
                <div className="mb15">
                  {GRAPH_POINTS.map((point) => {
                    return (
                      <div
                        className={cx(
                          'inline-block large-4 medium-4 small-12 mb5',
                          styles['graph-point'],
                          'mobile-only--mb20'
                        )}
                        key={point.point}
                      >
                        <img
                          className="verticle-align-middle mr10"
                          src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/${point.icon}`}
                        />
                        <span className="font--dark-grey mobile-only--text--xmd text--lg">
                          {point.point}
                        </span>
                      </div>
                    );
                  })}
                </div>
                <div className="large-12 medium-12 small-12 columns mb40 mobile-only--left mobile-only--mb10">
                  <p className="text--sm font--dark-grey mb20">
                    *Considering average returns of 15% for ELSS and 7-8%
                    returns for FD & PPF
                  </p>
                  <a
                    className="mb40"
                    href="https://cleartax.in/s/elss"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Know More about ELSS
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {splitCards ? this.renderSplitCards(splitCards, '', type) : null}
        {cards
          ? cards.map((card) => (
              <div
                className="large-4 columns mobile-only--mb20"
                key={card.bucketId}
              >
                {Array.isArray(buckets) ? (
                  <Card
                    key={card.bucketId}
                    data={
                      buckets.filter(
                        (bucket) => bucket.bucketId === card.bucketId
                      )[0]
                    }
                    id={id}
                    variant={variant}
                  />
                ) : null}
              </div>
            ))
          : null}

        {sections
          ? sections.map((section) => {
              const {
                title: sectionTitle,
                subtitle: sectionSubtitle,
                tabs: sectionTabs,
                id: tabSectionId,
              } = section;
              return (
                <Fragment key={`${title}${tabSectionId}`}>
                  <div
                    className={cx('columns', 'mt20', {
                      mb20: isElss,
                      mb40: !isElss,
                    })}
                  >
                    <h3
                      className={cx(
                        {
                          'text--xlg': isElss,
                          'text--xxlg': !isElss,
                        },
                        'font--bold font--dark-grey mobile-only--center'
                      )}
                    >
                      {sectionTitle}
                    </h3>
                    <p
                      className={cx(
                        'text--lg font--grey mobile-only--text--xmd desktop-only',
                        styles['line-height']
                      )}
                    >
                      {sectionSubtitle}
                    </p>
                  </div>
                  {sectionTabs ? (
                    <div className="columns mb40">
                      <Tabs
                        tabs={sectionTabs}
                        onTabClick={onTabClick}
                        sectionId={id}
                        tabSectionId={tabSectionId}
                        currentSelectedKey={this.props[tabSectionId]}
                      />
                    </div>
                  ) : null}
                  {sectionTabs
                    ? this.renderSplitCards(
                        sectionTabs.filter(
                          (tab) => tab.key === this.props[tabSectionId]
                        )[0].splitCards,
                        sectionTabs[0].scrollId
                      )
                    : null}
                </Fragment>
              );
            })
          : null}
        {tabs ? (
          <div className="columns mb40">
            <Tabs
              tabs={tabs.map((tab) => {
                const { key, label, scrollId } = tab;
                return {
                  key,
                  label,
                  scrollId,
                };
              })}
              onTabClick={onTabClick}
              sectionId={id}
              tabSectionId={id}
              currentSelectedKey={this.props[id]}
              key={`${id}${this.props[id]}`}
            />
          </div>
        ) : null}

        {selectedFund ? (
          <Fragment>
            <div className="large-4 columns" id={selectedFund.scrollId}>
              <p className="text--xlg font--bold font--darkgrey mobile-only--center">
                Top-performing {selectedFund.label}
              </p>
              <div className="desktop-only">
                <Checklist
                  items={TOP_FUNDS_STATIC[selectedFund.faqsKey]}
                  className="top-funds"
                />
              </div>
            </div>

            <div className="large-8 columns">
              <TopFundsSection
                data={{ funds: TopFundsMap[selectedFund.funds] }}
                startInvestment={startInvestment}
                handleRowClick={handleRowClick}
                addFundToCompare={addFundToCompare}
                id={id}
                variant={variant}
              />
            </div>
          </Fragment>
        ) : null}
      </div>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./components/home/section.tsx